export enum CONNECTION_TEST_STATUS {
	READY = 1,
	RUNNING,
	SUCCESS,
	ERROR
}
